export default __webpack_public_path__ + "static/media/PersonQuote.141bc7b6.svg";